import React from "react";
import { Grid } from "semantic-ui-react";
import { CustomButton } from "../button/Button";
import { DropDown } from "../selectDropDown/DropDown";
import "./DropDownWithButton.scss";

interface DropDownWithButtonProps {
  labelName: string;
  placeholder: string;
  currentData: any[];
  defaultValue?: any;
  required?: boolean;
  validate?: boolean;
  errorMessage?: string;
  customGridColumn?: string;
  handleChangeState: (e: any, data: any) => void;
  removeBoarderView?: boolean;
  disabled?: boolean;
  buttonTitle: string;
  buttonTheme?: "green" | "dark" | "blue" | "red" | "grey";
  buttonOnClick: () => void;
  buttonClassName?: string;
  buttonDisabled?: boolean;
}

const DropDownWithButton: React.FC<DropDownWithButtonProps> = ({
  labelName,
  placeholder,
  currentData,
  defaultValue,
  required,
  validate,
  errorMessage,
  customGridColumn,
  handleChangeState,
  removeBoarderView,
  disabled,
  buttonTitle,
  buttonTheme = "grey",
  buttonOnClick,
  buttonClassName,
  buttonDisabled
}) => {
  return (
    <Grid>
      <Grid.Column computer={16} tablet={16} mobile={16} className="relative dropdown-with-button">
        <DropDown
          labelName={labelName}
          placeholder={placeholder}
          currentData={currentData}
          defaultValue={defaultValue}
          required={required}
          validate={validate}
          errorMessage={errorMessage}
          customGridColumn={customGridColumn}
          handleChangeState={handleChangeState}
          removeBoarderView={removeBoarderView}
          disabled={disabled}
        />
        <div className="dropdown-button-wrapper">
          <CustomButton
            onClick={buttonOnClick}
            title={buttonTitle}
            theme={buttonTheme}
            className={buttonClassName}
            disabled={buttonDisabled}
          />
        </div>
      </Grid.Column>
    </Grid>
  );
};

export default DropDownWithButton;
